import { Component, EventEmitter, Input, OnChanges, Output, transition } from '@angular/core';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-chonso',
  templateUrl: 'chonso.component.html',
  styleUrls: ['/chonso.scss'],
})
export class ChonSoComponent implements OnChanges {

  @Input() TypeGame: string = 'lo2so'; // Default to generating 5 numbers
  @Input() TypeNhapSo: string = ''; // Default to generating 5 numbers
  TypeCount;
  // @Input() isDup: boolean = false; // Default to no duplicates
  @Output() chonSoNumber = new EventEmitter<string>();

  selectedOption: string = 'ngauNhien'; // Default selected option

  selectOption(option: string) {
    this.selectedOption = option;
  }
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('vi');
  }
  generateType = 0;
  generateTypeList = [1, 2, 3, 5, 10];
  generateTypeItXuatHien = [1, 2, 5, 10, 20];
  generateTypeItXuatHienYSelect = 0;
  generateTypeGoiYSelect: string = "";
  goiYInshow = ['lo2so', 'lo3so', 'lo4so', 'dedau', 'dedacbiet', 'dedauduoi', '4cangdacbiet', '3cangdau', '3cangdacbiet', '3cangduoi', '4cangdacbiet']
  itXuatHienInshow = ['lo2so', 'lo3so', 'lo4so', 'dedau', 'dedacbiet', 'dedauduoi', '3cangdau', '3cangdacbiet', '3cangduoi', '4cangdacbiet']

  generateTypeGoiY = [{
    type: 'kb',
    title: this.translate.instant('KEP_BANG'),
    in_type: ['lo2so', 'lo3so', 'lo4so', 'dedau', 'dedacbiet', 'dedauduoi', '3cangdau', '3cangdacbiet', '3cangduoi', '4cangdacbiet'],
    value_lo2so: '00;11;22;33;44;55;66;77;88;99;',
    value_dedau: '00;11;22;33;44;55;66;77;88;99;',
    value_dedacbiet: '00;11;22;33;44;55;66;77;88;99;',
    value_dedauduoi: '00;11;22;33;44;55;66;77;88;99;',
    value_lo3so: '000;011;022;033;044;055;066;077;088;099;100;111;122;133;144;155;166;177;188;199;200;211;222;233;244;255;266;277;288;299;300;311;322;333;344;355;366;377;388;399;400;411;422;433;444;455;466;477;488;499;500;511;522;533;544;555;566;577;588;599;600;611;622;633;644;655;666;677;688;699;700;711;722;733;744;755;766;777;788;799;800;811;822;833;844;855;866;877;888;899;900;911;922;933;944;955;966;977;988;999;',
    value_lo4so: '0000;0011;0022;0033;0044;0055;0066;0077;0088;0099;0100;0111;0122;0133;0144;0155;0166;0177;0188;0199;0200;0211;0222;0233;0244;0255;0266;0277;0288;0299;0300;0311;0322;0333;0344;0355;0366;0377;0388;0399;0400;0411;0422;0433;0444;0455;0466;0477;0488;0499;0500;0511;0522;0533;0544;0555;0566;0577;0588;0599;0600;0611;0622;0633;0644;0655;0666;0677;0688;0699;0700;0711;0722;0733;0744;0755;0766;0777;0788;0799;0800;0811;0822;0833;0844;0855;0866;0877;0888;0899;0900;0911;0922;0933;0944;0955;0966;0977;0988;0999;1000;1011;1022;1033;1044;1055;1066;1077;1088;1099;1100;1111;1122;1133;1144;1155;1166;1177;1188;1199;1200;1211;1222;1233;1244;1255;1266;1277;1288;1299;1300;1311;1322;1333;1344;1355;1366;1377;1388;1399;1400;1411;1422;1433;1444;1455;1466;1477;1488;1499;1500;1511;1522;1533;1544;1555;1566;1577;1588;1599;1600;1611;1622;1633;1644;1655;1666;1677;1688;1699;1700;1711;1722;1733;1744;1755;1766;1777;1788;1799;1800;1811;1822;1833;1844;1855;1866;1877;1888;1899;1900;1911;1922;1933;1944;1955;1966;1977;1988;1999;2000;2011;2022;2033;2044;2055;2066;2077;2088;2099;2100;2111;2122;2133;2144;2155;2166;2177;2188;2199;2200;2211;2222;2233;2244;2255;2266;2277;2288;2299;2300;2311;2322;2333;2344;2355;2366;2377;2388;2399;2400;2411;2422;2433;2444;2455;2466;2477;2488;2499;2500;2511;2522;2533;2544;2555;2566;2577;2588;2599;2600;2611;2622;2633;2644;2655;2666;2677;2688;2699;2700;2711;2722;2733;2744;2755;2766;2777;2788;2799;2800;2811;2822;2833;2844;2855;2866;2877;2888;2899;2900;2911;2922;2933;2944;2955;2966;2977;2988;2999;3000;3011;3022;3033;3044;3055;3066;3077;3088;3099;3100;3111;3122;3133;3144;3155;3166;3177;3188;3199;3200;3211;3222;3233;3244;3255;3266;3277;3288;3299;3300;3311;3322;3333;3344;3355;3366;3377;3388;3399;3400;3411;3422;3433;3444;3455;3466;3477;3488;3499;3500;3511;3522;3533;3544;3555;3566;3577;3588;3599;3600;3611;3622;3633;3644;3655;3666;3677;3688;3699;3700;3711;3722;3733;3744;3755;3766;3777;3788;3799;3800;3811;3822;3833;3844;3855;3866;3877;3888;3899;3900;3911;3922;3933;3944;3955;3966;3977;3988;3999;4000;4011;4022;4033;4044;4055;4066;4077;4088;4099;4100;4111;4122;4133;4144;4155;4166;4177;4188;4199;4200;4211;4222;4233;4244;4255;4266;4277;4288;4299;4300;4311;4322;4333;4344;4355;4366;4377;4388;4399;4400;4411;4422;4433;4444;4455;4466;4477;4488;4499;4500;4511;4522;4533;4544;4555;4566;4577;4588;4599;4600;4611;4622;4633;4644;4655;4666;4677;4688;4699;4700;4711;4722;4733;4744;4755;4766;4777;4788;4799;4800;4811;4822;4833;4844;4855;4866;4877;4888;4899;4900;4911;4922;4933;4944;4955;4966;4977;4988;4999;5000;5011;5022;5033;5044;5055;5066;5077;5088;5099;5100;5111;5122;5133;5144;5155;5166;5177;5188;5199;5200;5211;5222;5233;5244;5255;5266;5277;5288;5299;5300;5311;5322;5333;5344;5355;5366;5377;5388;5399;5400;5411;5422;5433;5444;5455;5466;5477;5488;5499;5500;5511;5522;5533;5544;5555;5566;5577;5588;5599;5600;5611;5622;5633;5644;5655;5666;5677;5688;5699;5700;5711;5722;5733;5744;5755;5766;5777;5788;5799;5800;5811;5822;5833;5844;5855;5866;5877;5888;5899;5900;5911;5922;5933;5944;5955;5966;5977;5988;5999;6000;6011;6022;6033;6044;6055;6066;6077;6088;6099;6100;6111;6122;6133;6144;6155;6166;6177;6188;6199;6200;6211;6222;6233;6244;6255;6266;6277;6288;6299;6300;6311;6322;6333;6344;6355;6366;6377;6388;6399;6400;6411;6422;6433;6444;6455;6466;6477;6488;6499;6500;6511;6522;6533;6544;6555;6566;6577;6588;6599;6600;6611;6622;6633;6644;6655;6666;6677;6688;6699;6700;6711;6722;6733;6744;6755;6766;6777;6788;6799;6800;6811;6822;6833;6844;6855;6866;6877;6888;6899;6900;6911;6922;6933;6944;6955;6966;6977;6988;6999;7000;7011;7022;7033;7044;7055;7066;7077;7088;7099;7100;7111;7122;7133;7144;7155;7166;7177;7188;7199;7200;7211;7222;7233;7244;7255;7266;7277;7288;7299;7300;7311;7322;7333;7344;7355;7366;7377;7388;7399;7400;7411;7422;7433;7444;7455;7466;7477;7488;7499;7500;7511;7522;7533;7544;7555;7566;7577;7588;7599;7600;7611;7622;7633;7644;7655;7666;7677;7688;7699;7700;7711;7722;7733;7744;7755;7766;7777;7788;7799;7800;7811;7822;7833;7844;7855;7866;7877;7888;7899;7900;7911;7922;7933;7944;7955;7966;7977;7988;7999;8000;8011;8022;8033;8044;8055;8066;8077;8088;8099;8100;8111;8122;8133;8144;8155;8166;8177;8188;8199;8200;8211;8222;8233;8244;8255;8266;8277;8288;8299;8300;8311;8322;8333;8344;8355;8366;8377;8388;8399;8400;8411;8422;8433;8444;8455;8466;8477;8488;8499;8500;8511;8522;8533;8544;8555;8566;8577;8588;8599;8600;8611;8622;8633;8644;8655;8666;8677;8688;8699;8700;8711;8722;8733;8744;8755;8766;8777;8788;8799;8800;8811;8822;8833;8844;8855;8866;8877;8888;8899;8900;8911;8922;8933;8944;8955;8966;8977;8988;8999;9000;9011;9022;9033;9044;9055;9066;9077;9088;9099;9100;9111;9122;9133;9144;9155;9166;9177;9188;9199;9200;9211;9222;9233;9244;9255;9266;9277;9288;9299;9300;9311;9322;9333;9344;9355;9366;9377;9388;9399;9400;9411;9422;9433;9444;9455;9466;9477;9488;9499;9500;9511;9522;9533;9544;9555;9566;9577;9588;9599;9600;9611;9622;9633;9644;9655;9666;9677;9688;9699;9700;9711;9722;9733;9744;9755;9766;9777;9788;9799;9800;9811;9822;9833;9844;9855;9866;9877;9888;9899;9900;9911;9922;9933;9944;9955;9966;9977;9988;9999;',
    value_3cangdau: '000;011;022;033;044;055;066;077;088;099;100;111;122;133;144;155;166;177;188;199;200;211;222;233;244;255;266;277;288;299;300;311;322;333;344;355;366;377;388;399;400;411;422;433;444;455;466;477;488;499;500;511;522;533;544;555;566;577;588;599;600;611;622;633;644;655;666;677;688;699;700;711;722;733;744;755;766;777;788;799;800;811;822;833;844;855;866;877;888;899;900;911;922;933;944;955;966;977;988;999;',
    value_3cangdacbiet: '000;011;022;033;044;055;066;077;088;099;100;111;122;133;144;155;166;177;188;199;200;211;222;233;244;255;266;277;288;299;300;311;322;333;344;355;366;377;388;399;400;411;422;433;444;455;466;477;488;499;500;511;522;533;544;555;566;577;588;599;600;611;622;633;644;655;666;677;688;699;700;711;722;733;744;755;766;777;788;799;800;811;822;833;844;855;866;877;888;899;900;911;922;933;944;955;966;977;988;999;',
    value_3cangduoi: '000;011;022;033;044;055;066;077;088;099;100;111;122;133;144;155;166;177;188;199;200;211;222;233;244;255;266;277;288;299;300;311;322;333;344;355;366;377;388;399;400;411;422;433;444;455;466;477;488;499;500;511;522;533;544;555;566;577;588;599;600;611;622;633;644;655;666;677;688;699;700;711;722;733;744;755;766;777;788;799;800;811;822;833;844;855;866;877;888;899;900;911;922;933;944;955;966;977;988;999;',
    value_4cangdacbiet: '0000;0011;0022;0033;0044;0055;0066;0077;0088;0099;0100;0111;0122;0133;0144;0155;0166;0177;0188;0199;0200;0211;0222;0233;0244;0255;0266;0277;0288;0299;0300;0311;0322;0333;0344;0355;0366;0377;0388;0399;0400;0411;0422;0433;0444;0455;0466;0477;0488;0499;0500;0511;0522;0533;0544;0555;0566;0577;0588;0599;0600;0611;0622;0633;0644;0655;0666;0677;0688;0699;0700;0711;0722;0733;0744;0755;0766;0777;0788;0799;0800;0811;0822;0833;0844;0855;0866;0877;0888;0899;0900;0911;0922;0933;0944;0955;0966;0977;0988;0999;1000;1011;1022;1033;1044;1055;1066;1077;1088;1099;1100;1111;1122;1133;1144;1155;1166;1177;1188;1199;1200;1211;1222;1233;1244;1255;1266;1277;1288;1299;1300;1311;1322;1333;1344;1355;1366;1377;1388;1399;1400;1411;1422;1433;1444;1455;1466;1477;1488;1499;1500;1511;1522;1533;1544;1555;1566;1577;1588;1599;1600;1611;1622;1633;1644;1655;1666;1677;1688;1699;1700;1711;1722;1733;1744;1755;1766;1777;1788;1799;1800;1811;1822;1833;1844;1855;1866;1877;1888;1899;1900;1911;1922;1933;1944;1955;1966;1977;1988;1999;2000;2011;2022;2033;2044;2055;2066;2077;2088;2099;2100;2111;2122;2133;2144;2155;2166;2177;2188;2199;2200;2211;2222;2233;2244;2255;2266;2277;2288;2299;2300;2311;2322;2333;2344;2355;2366;2377;2388;2399;2400;2411;2422;2433;2444;2455;2466;2477;2488;2499;2500;2511;2522;2533;2544;2555;2566;2577;2588;2599;2600;2611;2622;2633;2644;2655;2666;2677;2688;2699;2700;2711;2722;2733;2744;2755;2766;2777;2788;2799;2800;2811;2822;2833;2844;2855;2866;2877;2888;2899;2900;2911;2922;2933;2944;2955;2966;2977;2988;2999;3000;3011;3022;3033;3044;3055;3066;3077;3088;3099;3100;3111;3122;3133;3144;3155;3166;3177;3188;3199;3200;3211;3222;3233;3244;3255;3266;3277;3288;3299;3300;3311;3322;3333;3344;3355;3366;3377;3388;3399;3400;3411;3422;3433;3444;3455;3466;3477;3488;3499;3500;3511;3522;3533;3544;3555;3566;3577;3588;3599;3600;3611;3622;3633;3644;3655;3666;3677;3688;3699;3700;3711;3722;3733;3744;3755;3766;3777;3788;3799;3800;3811;3822;3833;3844;3855;3866;3877;3888;3899;3900;3911;3922;3933;3944;3955;3966;3977;3988;3999;4000;4011;4022;4033;4044;4055;4066;4077;4088;4099;4100;4111;4122;4133;4144;4155;4166;4177;4188;4199;4200;4211;4222;4233;4244;4255;4266;4277;4288;4299;4300;4311;4322;4333;4344;4355;4366;4377;4388;4399;4400;4411;4422;4433;4444;4455;4466;4477;4488;4499;4500;4511;4522;4533;4544;4555;4566;4577;4588;4599;4600;4611;4622;4633;4644;4655;4666;4677;4688;4699;4700;4711;4722;4733;4744;4755;4766;4777;4788;4799;4800;4811;4822;4833;4844;4855;4866;4877;4888;4899;4900;4911;4922;4933;4944;4955;4966;4977;4988;4999;5000;5011;5022;5033;5044;5055;5066;5077;5088;5099;5100;5111;5122;5133;5144;5155;5166;5177;5188;5199;5200;5211;5222;5233;5244;5255;5266;5277;5288;5299;5300;5311;5322;5333;5344;5355;5366;5377;5388;5399;5400;5411;5422;5433;5444;5455;5466;5477;5488;5499;5500;5511;5522;5533;5544;5555;5566;5577;5588;5599;5600;5611;5622;5633;5644;5655;5666;5677;5688;5699;5700;5711;5722;5733;5744;5755;5766;5777;5788;5799;5800;5811;5822;5833;5844;5855;5866;5877;5888;5899;5900;5911;5922;5933;5944;5955;5966;5977;5988;5999;6000;6011;6022;6033;6044;6055;6066;6077;6088;6099;6100;6111;6122;6133;6144;6155;6166;6177;6188;6199;6200;6211;6222;6233;6244;6255;6266;6277;6288;6299;6300;6311;6322;6333;6344;6355;6366;6377;6388;6399;6400;6411;6422;6433;6444;6455;6466;6477;6488;6499;6500;6511;6522;6533;6544;6555;6566;6577;6588;6599;6600;6611;6622;6633;6644;6655;6666;6677;6688;6699;6700;6711;6722;6733;6744;6755;6766;6777;6788;6799;6800;6811;6822;6833;6844;6855;6866;6877;6888;6899;6900;6911;6922;6933;6944;6955;6966;6977;6988;6999;7000;7011;7022;7033;7044;7055;7066;7077;7088;7099;7100;7111;7122;7133;7144;7155;7166;7177;7188;7199;7200;7211;7222;7233;7244;7255;7266;7277;7288;7299;7300;7311;7322;7333;7344;7355;7366;7377;7388;7399;7400;7411;7422;7433;7444;7455;7466;7477;7488;7499;7500;7511;7522;7533;7544;7555;7566;7577;7588;7599;7600;7611;7622;7633;7644;7655;7666;7677;7688;7699;7700;7711;7722;7733;7744;7755;7766;7777;7788;7799;7800;7811;7822;7833;7844;7855;7866;7877;7888;7899;7900;7911;7922;7933;7944;7955;7966;7977;7988;7999;8000;8011;8022;8033;8044;8055;8066;8077;8088;8099;8100;8111;8122;8133;8144;8155;8166;8177;8188;8199;8200;8211;8222;8233;8244;8255;8266;8277;8288;8299;8300;8311;8322;8333;8344;8355;8366;8377;8388;8399;8400;8411;8422;8433;8444;8455;8466;8477;8488;8499;8500;8511;8522;8533;8544;8555;8566;8577;8588;8599;8600;8611;8622;8633;8644;8655;8666;8677;8688;8699;8700;8711;8722;8733;8744;8755;8766;8777;8788;8799;8800;8811;8822;8833;8844;8855;8866;8877;8888;8899;8900;8911;8922;8933;8944;8955;8966;8977;8988;8999;9000;9011;9022;9033;9044;9055;9066;9077;9088;9099;9100;9111;9122;9133;9144;9155;9166;9177;9188;9199;9200;9211;9222;9233;9244;9255;9266;9277;9288;9299;9300;9311;9322;9333;9344;9355;9366;9377;9388;9399;9400;9411;9422;9433;9444;9455;9466;9477;9488;9499;9500;9511;9522;9533;9544;9555;9566;9577;9588;9599;9600;9611;9622;9633;9644;9655;9666;9677;9688;9699;9700;9711;9722;9733;9744;9755;9766;9777;9788;9799;9800;9811;9822;9833;9844;9855;9866;9877;9888;9899;9900;9911;9922;9933;9944;9955;9966;9977;9988;9999;',
  },
  {
    type: 'chan',
    title: this.translate.instant('CHAN'),
    in_type: ['lo2so', 'dedau', 'dedacbiet', 'dedauduoi'],
    value_lo2so: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;',
    value_dedau: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;',
    value_dedacbiet: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;',
    value_dedauduoi: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;'

  },
  {
    type: 'le',
    title: this.translate.instant('LE'),
    in_type: ['lo2so', 'dedau', 'dedacbiet', 'dedauduoi'],
    value_lo2so: '01;03;05;07;09;11;13;15;17;19;21;23;25;27;29;31;33;35;37;39;41;43;45;47;49;51;53;55;57;59;61;63;65;67;69;71;73;75;77;79;81;83;85;87;89;91;93;95;97;99;',
    value_dedau: '01;03;05;07;09;11;13;15;17;19;21;23;25;27;29;31;33;35;37;39;41;43;45;47;49;51;53;55;57;59;61;63;65;67;69;71;73;75;77;79;81;83;85;87;89;91;93;95;97;99;',
    value_dedacbiet: '01;03;05;07;09;11;13;15;17;19;21;23;25;27;29;31;33;35;37;39;41;43;45;47;49;51;53;55;57;59;61;63;65;67;69;71;73;75;77;79;81;83;85;87;89;91;93;95;97;99;',
    value_dedauduoi: '01;03;05;07;09;11;13;15;17;19;21;23;25;27;29;31;33;35;37;39;41;43;45;47;49;51;53;55;57;59;61;63;65;67;69;71;73;75;77;79;81;83;85;87;89;91;93;95;97;99;'
  },
  {
    type: 'lon',
    title: this.translate.instant('LON'),
    in_type: ['lo2so', 'dedau', 'dedacbiet', 'dedauduoi'],
    value_lo2so: '50;51;52;53;54;55;56;57;58;59;60;61;62;63;64;65;66;67;68;69;70;71;72;73;74;75;76;77;78;79;80;81;82;83;84;85;86;87;88;89;90;91;92;93;94;95;96;97;98;99;',
    value_dedau: '50;51;52;53;54;55;56;57;58;59;60;61;62;63;64;65;66;67;68;69;70;71;72;73;74;75;76;77;78;79;80;81;82;83;84;85;86;87;88;89;90;91;92;93;94;95;96;97;98;99;',
    value_dedacbiet: '50;51;52;53;54;55;56;57;58;59;60;61;62;63;64;65;66;67;68;69;70;71;72;73;74;75;76;77;78;79;80;81;82;83;84;85;86;87;88;89;90;91;92;93;94;95;96;97;98;99;',
    value_dedauduoi: '50;51;52;53;54;55;56;57;58;59;60;61;62;63;64;65;66;67;68;69;70;71;72;73;74;75;76;77;78;79;80;81;82;83;84;85;86;87;88;89;90;91;92;93;94;95;96;97;98;99;'
  },
  {
    type: 'nho',
    title: this.translate.instant('NHO'),
    in_type: ['lo2so', 'dedau', 'dedacbiet', 'dedauduoi'],
    value_lo2so: '00;01;02;03;04;05;06;07;08;09;10;11;12;13;14;15;16;17;18;19;20;21;22;23;24;25;26;27;28;29;30;31;32;33;34;35;36;37;38;39;40;41;42;43;44;45;46;47;48;49;',
    value_dedau: '00;01;02;03;04;05;06;07;08;09;10;11;12;13;14;15;16;17;18;19;20;21;22;23;24;25;26;27;28;29;30;31;32;33;34;35;36;37;38;39;40;41;42;43;44;45;46;47;48;49;',
    value_dedacbiet: '00;01;02;03;04;05;06;07;08;09;10;11;12;13;14;15;16;17;18;19;20;21;22;23;24;25;26;27;28;29;30;31;32;33;34;35;36;37;38;39;40;41;42;43;44;45;46;47;48;49;',
    value_dedauduoi: '00;01;02;03;04;05;06;07;08;09;10;11;12;13;14;15;16;17;18;19;20;21;22;23;24;25;26;27;28;29;30;31;32;33;34;35;36;37;38;39;40;41;42;43;44;45;46;47;48;49;'
  },
  ];

  generateTypeDeTopBot = [{
    type: 'detx',
    title: this.translate.instant('TAI_XIU'),
    in_type: ['detx'],
    selects: [
      {

      }
    ],
  },
  {
    type: 'chan',
    title: this.translate.instant('CHAN'),
    in_type: ['lo2so', 'dedau', 'dedacbiet', 'dedauduoi'],
    value_lo2so: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;',
    value_dedau: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;',
    value_dedacbiet: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;',
    value_dedauduoi: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;'

  },

  ];

  numberLoop = 1;
  isComma = false;
  ngOnChanges() {
    this.converTypeGame();
  }
  converTypeGame() {
    switch (this.TypeGame) {
      case 'lo2so':
        this.TypeCount = 2;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [1, 2, 3, 5, 10];
        break;
      case 'lo3so':
        this.TypeCount = 3;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [1, 2, 3, 5, 10];
        break;
      case 'lo4so':
        this.TypeCount = 4;
        this.numberLoop = 2
        this.isComma = false
        this.generateTypeList = [1, 2, 3, 5, 10];
        break;
      case 'lx2':
        this.TypeCount = 2;
        this.numberLoop = 2
        this.isComma = true
        this.generateTypeList = (this.TypeNhapSo == 'chonsonhanh') ? [1] : [1, 2, 3, 5, 10];
        break;
      case 'lx3':
        this.TypeCount = 2;
        this.numberLoop = 3
        this.isComma = true
        this.generateTypeList = (this.TypeNhapSo == 'chonsonhanh') ? [1] : [1, 2, 3, 5, 10];
        break;

      case 'lx4':
        this.TypeCount = 2;
        this.numberLoop = 4
        this.isComma = true
        this.generateTypeList = (this.TypeNhapSo == 'chonsonhanh') ? [1] : [1, 2, 3, 5, 10];
        break;

      case 'dedau':
        this.TypeCount = 2;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [10, 20, 30, 40, 50]
        break;
      case 'dedacbiet':
        this.TypeCount = 2;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [10, 20, 30, 40, 50]
        break;
      case 'dedauduoi':
        this.TypeCount = 2;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [10, 20, 30, 40, 50]
        break;
      case '3cangdau':
        this.TypeCount = 3;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [10, 20, 30, 40, 50]
        break;
      case '3cangdacbiet':
        this.TypeCount = 3;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [10, 20, 30, 40, 50]
        break;
      case '3cangdauduoi':
        this.TypeCount = 3;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [10, 20, 30, 40, 50]
        break;
      case '4cangdacbiet':
        this.TypeCount = 4;
        this.numberLoop = 1
        this.isComma = false
        this.generateTypeList = [10, 20, 30, 40, 50]
        break;
      case 'lt4':
        this.TypeCount = 2;
        this.numberLoop = 4
        this.isComma = true
        // this.generateTypeList = [1, 2, 3, 5, 10];
        this.generateTypeList = (this.TypeNhapSo == 'chonsonhanh') ? [1] : [1, 2, 3, 5, 10];
        break;
      case 'lt8':
        this.TypeCount = 2;
        this.numberLoop = 8
        this.isComma = true
        // this.generateTypeList = [1, 2, 3, 5, 10];
        this.generateTypeList = (this.TypeNhapSo == 'chonsonhanh') ? [1] : [1, 2, 3, 5, 10];
        break;
      case 'lt10':
        this.TypeCount = 2;
        this.numberLoop = 10
        this.isComma = true
        // this.generateTypeList = [1, 2, 3, 5, 10];
        this.generateTypeList = (this.TypeNhapSo == 'chonsonhanh') ? [1] : [1, 2, 3, 5, 10];
        break;
      case 'detx':
        this.TypeCount = 1;
        // this.numberLoop = 10
        // this.isComma = true
        // this.generateTypeList = [1, 2, 3, 5, 10];
        // this.generateTypeList = (this.TypeNhapSo == 'chonsonhanh') ? [1] : [1, 2, 3, 5, 10];
        break;

      default:
        this.TypeCount = 2;
        this.isComma = false
        this.generateTypeList = [1, 2, 3, 5, 10];
        break;
    }
  }
  // generateRandomNumbers(count: number, isDup: boolean = false) {
  //   this.generateType = count;
  //   const numbers: Set<number> | number[] = isDup ? [] : new Set();

  //   while ((isDup && (numbers as number[]).length < count) || (!isDup && (numbers as Set<number>).size < count)) {
  //     const randomNumber = Math.floor(Math.random() * 100); // Generates a random number between 0 and 99

  //     if (isDup) {
  //       (numbers as number[]).push(randomNumber); // Allow duplicates by pushing directly into array
  //     } else {
  //       (numbers as Set<number>).add(randomNumber); // Prevent duplicates by adding to Set
  //     }
  //   }

  //   // Convert the Set to an Array if duplicates are not allowed
  //   const formattedNumbers = Array.from(numbers).map(num => ('0'.repeat(this.TypeCount) + num).slice(-this.TypeCount));
  //   this.chonSoNumber.emit(formattedNumbers.join(';')); // 

  // }

  generateRandomNumbers(count: number, isDup: boolean = false) {
    this.generateType = count;
    const numbers: Set<number> | number[] = isDup ? [] : new Set();

    // Generate the required number of unique or duplicate numbers
    const requiredNumbers = count * this.numberLoop;
    while ((isDup && (numbers as number[]).length < requiredNumbers) || (!isDup && (numbers as Set<number>).size < requiredNumbers)) {
      // const randomNumber = Math.floor(Math.random() * 100); // Generates a random number between 0 and 99
      const randomNumber = Math.floor(Math.random() * 10 ** this.TypeCount);
      if (isDup) {
        (numbers as number[]).push(randomNumber); // Allow duplicates by pushing directly into array
      } else {
        (numbers as Set<number>).add(randomNumber); // Prevent duplicates by adding to Set
      }
    }

    // Convert the Set to an Array and format each number based on TypeCount
    const numbersArray = Array.from(numbers).map(num => ('0'.repeat(this.TypeCount) + num).slice(-this.TypeCount));

    // Group numbers by numberLoop, joining them with '&'
    const formattedNumbers = [];
    for (let i = 0; i < count; i++) {
      const group = numbersArray.slice(i * this.numberLoop, i * this.numberLoop + this.numberLoop);
      formattedNumbers.push(group.join('&'));
    }

    // Emit the formatted result joined by ';'
    this.chonSoNumber.emit(formattedNumbers.join(';'));
  }



  generateItXuatHien(count: number, isDup: boolean = false) {
    this.generateTypeItXuatHienYSelect = count;
    const typeCache = `it_${count}_${this.TypeCount}`;
    const numbers: Set<number> | number[] = isDup ? [] : new Set();
    if (sessionStorage.getItem(typeCache) != null) {
      this.chonSoNumber.emit(sessionStorage.getItem(typeCache));
      return;
    }
    while ((isDup && (numbers as number[]).length < count) || (!isDup && (numbers as Set<number>).size < count)) {

      const randomNumber = Math.floor(Math.random() * 10 ** this.TypeCount);


      if (isDup) {
        (numbers as number[]).push(randomNumber); // Allow duplicates by pushing directly into array
      } else {
        (numbers as Set<number>).add(randomNumber); // Prevent duplicates by adding to Set
      }
    }
    // const numbersArray = Array.from(numbers).map(num => ('0'.repeat(this.TypeCount) + num).slice(-this.TypeCount));
    // Convert the Set to an Array if duplicates are not allowed
    const formattedNumbers = Array.from(numbers).map(num => ('0'.repeat(this.TypeCount) + num).slice(-this.TypeCount));
    const stringData = formattedNumbers.join(';')
    sessionStorage.setItem(typeCache, stringData);
    this.chonSoNumber.emit(stringData); // 

  }

  generateGoiY(index: string) {
    this.generateTypeGoiYSelect = this.generateTypeGoiY[index].type;
    this.chonSoNumber.emit(this.generateTypeGoiY[index]['value_' + this.TypeGame]);
  }
  generateDeTopBot(index: string) {
    this.generateTypeGoiYSelect = this.generateTypeGoiY[index].type;
    this.chonSoNumber.emit(this.generateTypeGoiY[index]['value_' + this.TypeGame]);
  }

}



// WEBPACK FOOTER //
// ./src/component/chonso/chonso.component.ts